import type { Editor } from '@tiptap/react'
import type { z } from 'zod'

import { reportDocumentSchema, type ReportDocument } from '@/lib/report-document'

/** Şablon düzeyi alanlar (içerik dışında): başlık, yön, filtreler, adlandırılmış sorgular. */
export type DocumentTemplate = Pick<ReportDocument, 'title' | 'orientation' | 'filters' | 'queries'>

/**
 * Editör JSON'u = şema JSON'u. ProseMirror tanımsız öznitelikleri de yazar (`title: undefined`);
 * JSON'a çevirince düşer, geriye şemadaki biçim kalır.
 */
export function getDocumentJSON(editor: Editor): ReportDocument['content'] {
  return JSON.parse(JSON.stringify(editor.getJSON())) as ReportDocument['content']
}

export function buildDefinition(template: DocumentTemplate, content: ReportDocument['content']) {
  return { kind: 'document' as const, ...template, content }
}

export type DefinitionCheck = { ok: true } | { ok: false; errors: string[] }

/** Kaydetmeden önce `reportDocumentSchema` ile doğrular; hata varsa "yol: mesaj" listesi döner. */
export function checkDefinition(definition: unknown): DefinitionCheck {
  const parsed = reportDocumentSchema.safeParse(definition)
  if (parsed.success) return { ok: true }
  return {
    ok: false,
    errors: parsed.error.issues.map(
      (issue: z.core.$ZodIssue) => `${issue.path.join('.') || '/'}: ${issue.message}`,
    ),
  }
}
